import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import store from './store';
import { GlobalizationProvider } from '@Translations/GlobalizationProvider';

const queryClient = new QueryClient();

const env = localStorage.getItem('apiEnv') || process.env.REACT_APP_ENV || '';
const showDevtools =
	(env === 'LOCAL' || env === 'DEV') &&
	localStorage.getItem('reactQueryDevtools') === 'true';

ReactDOM.render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<Provider store={store}>
				<Suspense fallback="">
					<GlobalizationProvider>
						<App />
					</GlobalizationProvider>
				</Suspense>
			</Provider>
			{showDevtools && (
				<ReactQueryDevtools initialIsOpen={false} position="top-left" />
			)}
		</QueryClientProvider>
	</React.StrictMode>,
	document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
